export default {
  state: {
    count: 0
  },
  mutations: {
    increament(state) {
      state.count++
    }
  },
  getters: { // (state, getters)
    aliasCount: state => {
      return `count: ${state.count}`
    }
  },
  actions: {
    increament(context) {
      context.commit('increment')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/_example.js